<div class="white px-4 section-header">
    <h3>Data Found</h3>
    <p class="grey-text pt-3">View your data</p>
  </div>
  
  <div class="container-fluid pt-5 pb-5"> 
    <div class="pt-3 pb-5">
      <!-- <button mdbBtn class="pinkb white-text" (click)="exportExcel()">Export Data</button> -->
  
      <div *ngIf="userdata" class="mt-4 white">
        <!-- <button (click)="exportExcel()">Export as Excel</button> -->
        <app-user-data-list [userdata]="userdata" (userdataEdited)="onUserDataEdit($event)" (userdataDeleted)="onUserDataDelete($event)" (userdataSaved)="onUserDataSave($event)"></app-user-data-list>
      </div>
      
  
      <div *ngIf="isLoading$ | async" class="d-flex justify-content-center align-items-center" style="margin-top: 200px">
        <div class="spinner-grow text-primary" role="status" style="width: 4rem; height: 4rem;">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>   
  